import script from "./CatalogList.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogList.vue?vue&type=script&setup=true&lang=js"

import "./CatalogList.vue?vue&type=style&index=0&id=5305812d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5305812d"]])

export default __exports__